import { SortDir } from '@ui/src';

export const overviewAccountsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Date',
  },
  {
    name: 'counterpartyAccountNumber',
    label: 'Account No.',
  },
  {
    name: 'counterpartyAccountName',
    label: 'Account Name',
  },
  {
    name: 'type',
    label: 'Type',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'debitSum',
    label: 'Debit',
  },
  {
    name: 'creditSum',
    label: 'Credit',
  },
  {
    name: 'documentNumber',
    label: 'Doc ID',
    filterModalPlacement: 'right',
  },
];

export const overviewAccountsDefaultSorter = {
  sortProp: overviewAccountsColumns[1].name,
  sortDir: SortDir.DESC,
};

export const overviewAccountsColumnsLabels = {
  transferDate: 'Date',
  transferDateFrom: 'Date From',
  transferDateTo: 'Date To',
  type: 'Type',
  currencyId: 'Currency',
  documentNumber: 'Doc ID',
  debitSum: 'Debit',
  creditSum: 'Credit',
};

export const overviewAccountsSchema = {};

export const overviewAccountsFiltersSchema = [];
